export default class DescriptiveTextRenderOptions {
  constructor(public speed?: number) {}
}
